import { useState, useEffect } from 'react';
import { teamNewService } from '../services/teamNew.service';
import type { NewReferenceData, TeamNewFormValues } from '../types/teamNew.types';
import { useAuth } from '@/core/auth/AuthContext';

export function useTeamNew(companyId: string) {
  const { user } = useAuth();
  const userId = user?.id || '';
  
  const [referenceData, setReferenceData] = useState<NewReferenceData>({ 
    projects: [], 
    users: [],
    departments: [],
    zones: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    async function load() {
      if (!companyId || !userId) return;
      try {
        const data = await teamNewService.getReferenceData(companyId, userId);
        setReferenceData(data);
      } catch (err) {
        console.error('[useTeamNew] Error loading ref data:', err);
      } finally {
        setIsLoading(false);
      }
    }
    load();
  }, [companyId, userId]);

  const createTeam = async (values: TeamNewFormValues) => {
    if (!userId) return;
    setIsSubmitting(true);
    try {
      const res = await teamNewService.createTeam(companyId, values, userId);
      return res;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    referenceData,
    isLoading,
    isSubmitting,
    createTeam
  };
}
